import React from 'react';

export default function SelectTopLabel(props) {
  const hasError = Boolean(props.errorMessage);
  const isRepList = props.isRepList

  return (
    <div
      className={`form-input form-select__wrapper ${
        props.className ? props.className : ''
      } ${props.isValid && !hasError ? 'form-input--success' : ''} ${
        hasError ? 'form-input--error' : ''
      } ${props.disabled ? 'form-input--disabled' : ''}`}
    >
      <select
        className={`form-select form-select-top ${props.filled ? 'form-select-top--filled' : ''}`}
        id={props.id}
        name={props.name}
        disabled={props.disabled}
        aria-label={props.label}
        value={ isRepList ? props.value : props.value?.toLowerCase()}
        {...props.fieldProps}
        {...props.register?.(props.name, { required: props.required })}
      >
        {!!props.placeholder && (
          <option value="">
            {props.placeholder}
            {props.required && '*'}
          </option>
        )}
        {props.options?.map(opt => (
          <option key={opt.value} value={isRepList ? opt.value : opt.value.toLowerCase()}>
            {opt.label}
          </option>
        ))}
      </select>
      <label className="form-select-top__label" htmlFor={props.id}>
        {props.label}
      </label>
      <svg className="form-input__select-arrow" viewBox="0 0 120 120">
        <use xlinkHref="#chevron-down" />
      </svg>
      {hasError && <p className="form-input__error">{props.errorMessage}</p>}
    </div>
  );
}
